import { defineRouteDef, z } from '@/domains/common/api';

export const listSponsorsRoute = defineRouteDef({
  method: 'GET',
  path: '/api/sponsors/list',
  audience: 'user',
  output: z.object({
    sponsors: z.array(z.object({ id: z.string(), name: z.string() })),
  }),
});
